/**
 * Concaténation de classes CSS — l’équivalent maison de `clsx`, sans dépendance.
 *
 * ```ts
 * cn('px-3 py-2', actif && 'bg-rideau-700 text-white', className)
 * ```
 *
 * Les valeurs fausses sont ignorées. Les classes passées en dernier gagnent
 * lorsqu’elles ne se contredisent pas ; en cas de conflit réel entre deux
 * utilitaires Tailwind, c’est l’ordre de la feuille de style qui tranche —
 * les primitives de `src/ui/` sont donc écrites pour n’exposer que des variantes
 * fermées plutôt que d’inviter à écraser leurs classes.
 */
export type ValeurClasse = string | false | null | undefined

export function cn(...valeurs: readonly ValeurClasse[]): string {
  let resultat = ''
  for (const valeur of valeurs) {
    if (typeof valeur !== 'string' || valeur === '') continue
    resultat = resultat === '' ? valeur : `${resultat} ${valeur}`
  }
  return resultat
}
